import { Flex, Text, spaces } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

import { AssetDetailsBaseCard } from '@/pages/Assets/AssetDetailsContent/AssetDetailsBaseCard';

type AssetNotesCardProps = {
  value: string;
  cardTitle?: string;
};

const AssetNotesCard = ({ value, cardTitle }: AssetNotesCardProps) => {
  const { t } = useTranslation('assets');
  const defaultTitle = t('assetDetailsContent.notes');
  const { space_5xl, space_m } = spaces;

  return (
    <Flex height="100%" width="100%" alignItems="stretch">
      <AssetDetailsBaseCard title={cardTitle ?? defaultTitle} icon="note">
        <Flex width="100%" pt={space_m} pl={space_5xl} pr={space_m}>
          <Text>{value}</Text>
        </Flex>
      </AssetDetailsBaseCard>
    </Flex>
  );
};

export default AssetNotesCard;
